'use strict';

/** @type {import('./type')} */
module.exports = TypeError;



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-errors/type.js
// module id = 9
// module chunks = 0